import React from 'react';
import { useTranslation } from 'react-i18next';
import GitBranchIcon from '@mui/icons-material/CallSplit';
import AddIcon from '@mui/icons-material/Add';
import { TextField as MuiTextField, MenuItem, InputAdornment, CircularProgress } from '@mui/material';
import styles from './BranchSelect.scss';

const sx = {
  textField: {
    width: '100%'
  },
  selectMenu: {
    '& .MuiMenuItem-root': {
      fontSize: 14,
      color: 'var(--font-color)',
      height: 31,
      padding: '6px 16px',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  }
};

const BranchSelect = ({ currentKgId, isMainBranch, branches = [], isCreating, onBranchSwitch, disabled = false }) => {
  const { t } = useTranslation();

  const menuItems = disabled
    ? [
        <MenuItem key="no-kg" value="">
          No KG selected
        </MenuItem>
      ]
    : [
        ...branches.map(branch => (
          <MenuItem key={branch.id} value={branch.id}>
            {branch.name}
          </MenuItem>
        )),
        <MenuItem key="create-new" value="create-new" className="createBranchMenuItem" disabled={isCreating}>
          {isCreating ? (
            <CircularProgress size={16} className={styles.createBranchIcon} />
          ) : (
            <AddIcon className={styles.createBranchIcon} />
          )}
          {isCreating ? t('branch.creating') : t('branch.create-new-branch')}
        </MenuItem>
      ];

  return (
    <div style={{ width: '100%' }}>
      <MuiTextField
        sx={sx.textField}
        select
        value={currentKgId || ''}
        onChange={e => onBranchSwitch(e.target.value)}
        className={`${styles.branchSelect} ${isMainBranch ? styles.mainBranch : styles.devBranch}`}
        disabled={disabled}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <GitBranchIcon className={`${styles.gitIcon} ${isMainBranch ? styles.mainBranch : styles.devBranch}`} />
            </InputAdornment>
          )
        }}
        SelectProps={{
          MenuProps: {
            anchorOrigin: { vertical: 'center', horizontal: 'right' },
            transformOrigin: { vertical: 'center', horizontal: 'left' },
            sx: sx.selectMenu
          }
        }}
      >
        {menuItems}
      </MuiTextField>
      <GitBranchIcon
        className={`${styles.gitIcon} ${styles.iconOnly} ${isMainBranch ? styles.mainBranch : styles.devBranch}`}
      />
    </div>
  );
};

export default BranchSelect;
